// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radar-alerting-manoeuvre.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radar-alerting-manoeuvre/radar-alerting-manoeuvre.js';

mount([g0]);
